const SoldGiftVoucher = require('@/lib/GiftVouchers/SoldGiftVoucher');

/**
 * Handles things to do with redeeming gift vouchers that are already sold (SoldGiftVouchers).
 */
class SoldGiftVoucherManager {
    /**
     * @param {ApiClient} apiClient
     * @param {Hydrator} hydrator
     */
    constructor(
        apiClient,
        hydrator,
    ) {
        this.apiClient = apiClient;
        this.hydrator = hydrator;
    }

    /**
     * @param {string} ref
     *
     * @return {Promise<SoldGiftVoucher|null>}
     */
    findByRef(ref) {
        return this.apiClient
            .request(
                'GET',
                'soldgiftvouchers',
                {
                    ref,
                    resolve: 'giftvoucher,recipient',
                },
            )
            .then((response) => {
                console.log('response', response);
                if (response && response.data && response.data.length > 0) {
                    const soldGiftVoucher = this.hydrator.hydrate(response.data[0], new SoldGiftVoucher());

                    return soldGiftVoucher;
                }

                return null;
            });
    }
}

module.exports = SoldGiftVoucherManager;
